
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllJobs } from "@utils/get-jobs";
import Image from "next/image";
import Link from "next/link";
import type { GetStaticProps, NextPage } from "next/types";
interface IJob {
    jobs: {
        title: string;
        slug: string;
        jobOfferDetails: {
            location: string;
        };
    }[];
}
const Career: NextPage<IJob> = ({ jobs }) => (<div className="bg-white">
    <div className="w-full bg-black text-white">
      <Image alt="Fabryka okien KNS" className="w-full" height="729" src="/img/career/produkcja.jpg" width="1920"/>
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          Pracuj w KNS Śląska Fabryka Okien
        </h1>
        <div className="py-3"/>
        KNS może się poszczycić stałym wzrostem, na który pracuje
        wykwalifikowany personel. Posiadamy jeden z najnowocześniejszych parków
        technologicznych, jakie można spotkać w branży stolarki otworowej,
        zarówno w Polsce, jak i w Europie. Kładziemy też duży nacisk na
        inwestycje w kapitał ludzki, jako najważniejszy filar nowoczesnego
        biznesu.
        <br />
        <br />
        <strong>Dołącz do dynamicznie rozwijającej się firmy!</strong>
      </div>
    </div>
    <div className="w-full pb-6">
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          DLACZEGO KNS?
        </h1>
        <div className="py-3"/>
        Śląska Fabryka Okien KNS już na starcie pomaga w samorealizacji oraz
        wspiera dodatkowymi szkoleniami. Pracownicy mają możliwość zdobywania
        wartościowych uprawnień, a także uczestniczenia w zróżnicowanych kursach
        organizowanych w siedzibie firmy oraz wyjazdowych. Załoga firmy, poza
        pracą w firmie o ugruntowanej pozycji na rynku, w doświadczonym zespole
        i z atrakcyjnym wynagrodzeniem, może również liczyć na szereg benefitów.
      </div>
    </div>
    <div className="w-full pb-6">
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          KOGO SZUKAMY?
        </h1>
        <div className="py-3"/>
        Każdego dnia w naszej firmie powstają setki okien i drzwi. Aby utrzymać
        wysoki standard produkcji i sprostać rosnącym wymaganiom rynku krajowego
        oraz zagranicznego, poszukujemy zaangażowanych pracowników, którzy chcą
        rozwijać się razem z nami.
        <br />
        <br />
        <strong>Chcesz być częścią naszego zespołu? Dołącz do KNS!</strong>
      </div>
    </div>
    <div className="w-full bg-white">
      <Image alt="Praca w KNS" height="555" src="/img/career/firma.jpg" width="1920"/>
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          OFERTY PRACY
        </h1>
        <div className="py-1 text-center"/>
        Sprawdź aktualne oferty pracy
      </div>
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <div className="flex border font-thin text-gray-500">
          <div className="w-max-fit flex-auto p-1 text-left">Stanowisko</div>
          <div className="hidden w-48 flex-initial border-l p-1 md:block">
            Miejsce pracy
          </div>
          <div className="hidden w-48 flex-initial border-l md:block"/>
        </div>
        {jobs.map((job) => (<div className="flex flex-wrap border" key={job.slug}>
            <div className="w-full flex-auto p-1 text-left font-bold md:w-max">
              {job?.title}
            </div>
            <div className="w-1/2 flex-initial p-1 md:w-48 md:border-l">
              {job.jobOfferDetails.location
            ? job.jobOfferDetails.location
            : "-"}
            </div>
            <div className="w-1/2 flex-initial md:w-48 md:border-l">
              <Link className="relative top-1 bg-gradient-to-r from-red to-orange px-2 py-1 text-sm text-white uppercase hover:bg-gradient-to-l" href={`/career/${job.slug}`}>
                Pokaż szczegóły
              </Link>
            </div>
          </div>))}
      </div>
    </div>
    <div className="w-full bg-black pb-6 text-white">
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          NIE ZNALAZŁEŚ OFERTY DLA SIEBIE?
        </h1>
        <div className="py-1">
          Wyślij do nas e-mail ze swoimi CV (napisz coś o sobie, doświadczenie
          itp.) i zostaw kontakt do siebie.
        </div>
        <div className="py-1 font-bold">rekrutacja@kns-okna.pl</div>
        <div className="py-1 font-bold">Rekrutacja: +48 514 602 062</div>
      </div>
    </div>
    <div className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8 lg:py-6">
        <h1 className="my-3 inline-block bg-gradient-to-r from-red to-orange px-4 py-1 font-bold text-white text-xl">
          CO OFERUJEMY
        </h1>
        <div className="flex flex-wrap items-center justify-center py-1">
          <div className="m-1 w-36 min-w-[120px] text-center">
            <Image alt="warunki pracy" className="mx-auto" height={96} src="/img/career/warunki-pracy.png" width={96}/>
            stabilne warunki pracy (umowa o pracę)
          </div>
          <div className="m-1 w-36 min-w-[120px] text-center">
            <Image alt="warunki pracy" className="mx-auto" height={96} src="/img/career/samodzielnosc.png" width={96}/>
            Samodzielność i zaufanie
          </div>
          <div className="m-1 w-36 min-w-[120px] text-center">
            <Image alt="warunki pracy" className="mx-auto" height={96} src="/img/career/benefity.png" width={96}/>
            Benefity (karty multisport)
          </div>
          <div className="m-1 w-36 min-w-[120px] text-center">
            <Image alt="warunki pracy" className="mx-auto" height={96} src="/img/career/ubezpieczenie-grupowe.png" width={96}/>
            Ubezpieczenie grupowe
          </div>
          <div className="m-1 w-36 min-w-[120px] text-center">
            <Image alt="warunki pracy" className="mx-auto" height={96} src="/img/career/mozliwosc-rozwoju.png" width={96}/>
            Szerokie możliwości rozwoju
          </div>
        </div>
      </div>
    </div>
  </div>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const _LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { jobs } = await getAllJobs();
    return {
        props: {
            jobs,
        },
    };
};
export default Career;

    async function __Next_Translate__getStaticProps__1a1a83a9483__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/career/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1a83a9483__ as getStaticProps }
  